import Image from '@tiptap/extension-image'
import crossIcon from '@/assets/ic_cross.svg'

export default Image.extend({
  addNodeView() {
    return ({ HTMLAttributes, editor, getPos, node }) => {
      const container = document.createElement('div')
      const image = document.createElement('img')
      const deleteButton = document.createElement('button')
      const buttonIcon = document.createElement('img')

      container.classList.add('custom-image-container')
      deleteButton.classList.add('custom-image-delete')
      image.classList.add('custom-image-image')

      image.setAttribute('src', HTMLAttributes.src)
      buttonIcon.setAttribute('src', crossIcon)

      deleteButton.append(buttonIcon)
      container.append(deleteButton)
      container.append(image)

      deleteButton.addEventListener('click', () => {
        const from = getPos()
        const to = from + node.nodeSize
        editor.commands.deleteRange({ from, to })
      })
      container.addEventListener('focus', () => {
        container.classList.add('selected')
      })
      container.addEventListener('blur', () => {
        container.classList.remove('selected')
      })

      return {
        dom: container
      }
    }
  }
})
